import { defineMessages } from 'react-intl';
import type { CalendarState } from './calendarFilterModel';

/** The word of each Calendar state (design b10). The mark is never the only sign. */
export const calendarStateMessages = defineMessages<CalendarState>({
  needsYou: { id: 'app.sml.promote.calendar.state.needsYou', defaultMessage: 'Needs you' },
  failed: { id: 'app.sml.promote.calendar.state.failed', defaultMessage: 'Failed' },
  draft: { id: 'app.sml.promote.calendar.state.draft', defaultMessage: 'Draft' },
  scheduled: { id: 'app.sml.promote.calendar.state.scheduled', defaultMessage: 'Scheduled' },
  published: { id: 'app.sml.promote.calendar.state.published', defaultMessage: 'Published' },
  canceled: { id: 'app.sml.promote.calendar.state.canceled', defaultMessage: 'Canceled' },
});

/** The plural words of the State filter (design b8). */
export const calendarStateFilterMessages = defineMessages<CalendarState>({
  needsYou: { id: 'app.sml.promote.calendar.filter.needsYou', defaultMessage: 'Needs you' },
  failed: { id: 'app.sml.promote.calendar.filter.failed', defaultMessage: 'Failed' },
  draft: { id: 'app.sml.promote.calendar.filter.drafts', defaultMessage: 'Drafts' },
  scheduled: { id: 'app.sml.promote.calendar.filter.scheduled', defaultMessage: 'Scheduled' },
  published: { id: 'app.sml.promote.calendar.filter.published', defaultMessage: 'Published' },
  canceled: { id: 'app.sml.promote.calendar.filter.canceled', defaultMessage: 'Canceled' },
});

export const calendarMessages = defineMessages({
  title: { id: 'app.sml.promote.tab.calendar', defaultMessage: 'Calendar' },
  newPost: { id: 'app.sml.promote.calendar.newPost', defaultMessage: 'New post' },
  publishing: { id: 'app.sml.promote.calendar.state.publishing', defaultMessage: 'Going out now' },
  needsSettings: { id: 'app.sml.promote.calendar.state.needsSettings', defaultMessage: 'Needs your settings' },
  makingClip: { id: 'app.sml.promote.calendar.state.makingClip', defaultMessage: 'Making the clip' },
  textPost: { id: 'app.sml.promote.calendar.textPost', defaultMessage: 'Aa' },
  story: { id: 'app.sml.promote.post.story', defaultMessage: 'Story' },
  post: { id: 'app.sml.promote.post.post', defaultMessage: 'Post' },
  cardLabel: {
    id: 'app.sml.promote.calendar.card.label',
    defaultMessage: '{platform}, {time}, {title}, {format}, {state}',
  },
  releaseBand: { id: 'app.sml.promote.calendar.release.band', defaultMessage: '{title} is out' },
  releaseToday: { id: 'app.sml.promote.calendar.release.today', defaultMessage: '{title} is out today' },
  moreCount: { id: 'app.sml.promote.calendar.more', defaultMessage: '+{count} more' },
  moreCountShort: { id: 'app.sml.promote.calendar.more.short', defaultMessage: '+{count}' },
  add: { id: 'app.sml.promote.calendar.add', defaultMessage: '+ Add' },
  addOnDay: { id: 'app.sml.promote.calendar.add.label', defaultMessage: 'Add a post on {day}' },
  timezone: { id: 'app.sml.promote.calendar.timezone', defaultMessage: 'Times in {zone}' },
  dropRefused: {
    id: 'app.sml.promote.calendar.move.refused',
    defaultMessage: 'A post cannot move to a time in the past.',
  },
  moveBusy: {
    id: 'app.sml.promote.calendar.move.busy',
    defaultMessage: 'This post is going out now, so it cannot move.',
  },
  movedDraft: {
    id: 'app.sml.promote.calendar.move.doneDraft',
    defaultMessage: 'Moved to {time}. It is still a draft.',
  },
  moved: { id: 'app.sml.promote.calendar.move.done', defaultMessage: 'Moved to {time}.' },
  undo: { id: 'app.sml.promote.calendar.move.undo', defaultMessage: 'Undo' },
  pickedUp: {
    id: 'app.sml.promote.calendar.move.pickedUp',
    defaultMessage:
      'Picked up: {platform} {state}, {title}, {time}. Arrow keys move it by a day, Shift and the arrows by a week. Enter drops it. Escape cancels.',
  },
  pickedUpWeek: {
    id: 'app.sml.promote.calendar.move.pickedUpWeek',
    defaultMessage:
      'Picked up: {platform} {state}, {title}, {time}. Left and right move it by a day, up and down by 15 minutes. Enter drops it. Escape cancels.',
  },
  moveTo: { id: 'app.sml.promote.calendar.move.to', defaultMessage: 'Move to {time}.' },
  moveCanceled: { id: 'app.sml.promote.calendar.move.canceled', defaultMessage: 'The move is canceled.' },
});
